import React from 'react';
import AltLineContainer from '../containers/AltLineContainer';
import LineTable from './LineTable';

class LineGroup extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      didAdd: false,
    };
    this.createAlt = this.createAlt.bind(this);
    // this.handleSelect = this.handleSelect.bind(this);
  }

  createAlt(e) {
    e.preventDefault();
    this.setState({ ...this.state, didAdd: true });
    this.props.onCreate();
  }

  // handleSelect(ev, altLineId) {
  //   ev.preventDefault;
  //   if (this.props.onSelect) this.props.onSelect(altLineId);
  // }

  render() {
    const { props } = this;
    return (
      <div>
        {props.lines && (
          <div>
            <LineTable uiToggles={props.ui.toggles}>
              {props.lines.map((alt, index) => (
                <AltLineContainer
                  key={alt.id}
                  index={index}
                  line={alt}
                  linegroup={props.linegroup}
                  selected={alt.id === props.line.id}
                  onSelect={props.onSelect}
                  autoFocus={props.autoFocus || this.state.didAdd || false}
                />
              ))}
            </LineTable>
            <div className="card-body mt-0 pt-0">
              <a href="#add-alt-line" className="card-link" onClick={this.createAlt}>
                Add
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default LineGroup;



// WEBPACK FOOTER //
// ./src/components/LineGroup.js